import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=21bf3940&scoped=true&"
import script from "./err404.vue?vue&type=script&lang=js&"
export * from "./err404.vue?vue&type=script&lang=js&"
import style0 from "./err404.vue?vue&type=style&index=0&id=21bf3940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf3940",
  null
  
)

export default component.exports